<template>
  <TradePanel :title="title">
    <AskBidPrices :stock="stock" context="trade" />
    <TradeStatus />
    <OrderForm v-if="tradeRequest.order" />
  </TradePanel>
</template>
<script>
import AskBidPrices from 'mod/AskBidPrices'
import TradePanel from './TradePanel'
import OrderForm from './OrderForm'
import TradeStatus from './TradeStatus'
import { SEC_TYPE } from 'const/stock'
import { TIMER_EXPRESSION } from 'const/common'
import { mapGetters } from 'vuex'
import isNeedRefresh from 'utils/isNeedRefresh'
import { getQuoteDetail } from 'apis/quote'
import isSameStock from 'utils/isSameStock'
import * as types from 'store/mutation-types'

const POLL_OPT_DETAIL = 'poll option detail'

export default {
  name: 'TardeView',
  components: {
    TradePanel,
    AskBidPrices,
    OrderForm,
    TradeStatus
  },
  computed: {
    ...mapGetters([
      'permission',
      'tradeRequest',
      'hasModifyOrderRequest',
      'activeStock'
    ]),
    stock() {
      return this.tradeRequest.stock
    },
    isOPT() {
      return this.stock && this.stock.secType === SEC_TYPE.OPT
    },
    title() {
      if (this.isOPT) {
        return this.$options.filters.formatOptionName(this.stock, 0)
      }
      return this.stock.symbol + ' ' + this.stock.nameCN
    },
    isSameStock() {
      return isSameStock(this.activeStock, this.stock)
    }
  },
  data() {
    return {
      timer: null
    }
  },
  created() {
    const isNeedPoll = isNeedRefresh(this.stock, this.$store.getters)
    // 期权修改订单买卖盘盘中且未打开个股页需要更新
    if (
      this.hasModifyOrderRequest &&
      this.isOPT &&
      isNeedPoll &&
      !this.isSameStock
    ) {
      this.timer = this.$cron(TIMER_EXPRESSION.OPT_DETAIL).interval(
        POLL_OPT_DETAIL,
        this.getOptionQuoteDetail
      )
    }
  },
  methods: {
    getOptionQuoteDetail() {
      getQuoteDetail(this.stock).then(detail => {
        this.$store.commit(types.UPDATE_TRADE_STOCK, detail)
      })
    }
  },
  beforeDestroy() {
    if (this.timer) {
      this.timer.clear()
      this.timer = null
    }
  }
}
</script>
